import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { BaseIcon, Row, LoaderIndicator } from '@warrenbrasil/nebraska-web';

import { PortfolioBrokerageNote } from '@/modules/wealth/services/portfolio';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface Props {
  brokerageNote: PortfolioBrokerageNote;
  disabled: boolean;
  loading: boolean;
}
interface Emits {
  (event: 'on-click'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BrokerageNoteRow',
  props: {
    brokerageNote: null,
    disabled: { type: Boolean },
    loading: { type: Boolean }
  },
  emits: ["on-click"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'on-click'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  brokerageNote: PortfolioBrokerageNote;
  disabled: boolean;
  loading: boolean;
};





const computedClass = computed(() => {
  return {
    'note-row--default': true,
    'note-row--disabled': props.disabled,
    'note-row--loading': props.loading
  };
});

const iconColor = computed(() => {
  return props.disabled || props.loading
    ? NebraskaColors.elementDisabled
    : NebraskaColors.elementSecondary;
});

const onClick = () => {
  if (props.disabled || props.loading) return;
  emit('on-click');
};

return { __sfc: true,props, emit, computedClass, iconColor, onClick, BaseIcon, Row, LoaderIndicator }
}

})